<script lang="ts">
    export let saved = false;
</script>
<span class="SavedIndicator" class:saved={saved} title={saved ? 'Saved' : 'Has unsaved changes'}>{saved ? '✓':'⬤'}</span>
<style type="text/scss">
    .SavedIndicator {
        font-family: monospace;
        width: 10px;
        display: inline-block;
        text-align: center;
        cursor: context-menu;
        &.saved {
            color: #ccc;
        }
    }
</style>